import React, { PureComponent , createRef } from "react";
// import Web3 from "web3";
import { Redirect} from "react-router-dom";
// import { getWeb3, checkWeb3 } from "../getWeb3";
import moment from 'moment';

import metaMaskStore from '../../components/metaMask'
import '../../assets/jntr_useprofile/css/animate.css';
// import '../../assets/jntr_useprofile/css/boilerplate.css';
import '../../assets/jntr_useprofile/css/flags.css';
// import '../../assets/jntr_useprofile/css/protip.min02.css';
import '../../assets/jntr_useprofile/css/user-style.css';
import '../../assets/jntr_useprofile/css/user-responsive.css';
import * as AuctionActions from '../../actions/AuctionActions'
import * as WhiteListActions from '../../actions/WhiteListActions';
import auctionStores from '../../stores/AuctionStores'
import CONSTANT, { WS_URL} from '../../constant'

import * as ContractData from '../../ContractData';
import * as notification from '../../helpers/notificationHelper'
import wowjs from 'wowjs'
import Header from "./components/profile/header";
import CurrentlyActiveWallet from "./components/profile/currentlyActiveWallet";
import LedgerBox from "./components/profile/ledgerBox";
import IdentityVerification from "./components/profile/identityVerification";
import AddFunds from "./components/profile/popups/addFunds";
// import AddFunds from "../auction/components/addFund"
import DeleteConfirmation from "./components/profile/popups/deleteConfirmation";
import WalletPopup from "./components/profile/popups/walletPopup";
import ChangeEmail from "./components/profile/popups/changeEmail";
import LinkNewWallet from "./components/profile/popups/linkNewWallet";
import VerifyCode from "./components/profile/popups/verifyCode";
import ChangePhone from "./components/profile/popups/changePhone";
import Footer from "../auction/components/footer2";
import Loader from "./components/loader";
// import YourOtherWallets from "./components/profile/yourOtherWallets";


const $ = window.$;
const jQuery = window.jQuery;

class Profile extends PureComponent {

    constructor(props) {
        super(props);
        this.whiteListAddress = this.whiteListAddress.bind(this);
        this.getDownSideInfo = this.getDownSideInfo.bind(this);
        this.copyJNTRAddressRef =  createRef();
        this.copyJNTRETNAddressRef = createRef();
        this.copyJNTRStockAddressRef = createRef();
        this.state = {
            web3Provider: {
                web3: null,
                metaMaskInstalled: false,
                isLogin: false,
                netWorkId: 0,
                accounts: []
            },
            lockedTokens: 0,
            jntrInstance:null,
            accounts: null,
            contract: null,
            loading: true,
            redirectToLogin: false,
            redirectToAuction: false,
            redirectToEmailVerification: false,
            metamaskWallet: null,
            ledgerWallet: null,
            whiteListInstance: null,
            downSideProtectionInstance: null,
            fundCollectorInstance: null,
            jntrBalance:null,
            userProfile: {
                kycStatus: false,
                amlStatus: false,
                accreditationStatus: false,
                details: {
                    first_name: "",
                    last_name: "",
                    middle_name: "",
                    country: ""
                },
                wallets: [""],
                unapprovedWallets: [""],
                email: "",
                phone: "",
                countryCode: "",
                address: "",
                kycId: ""
            },
            tokenBalance:{
                BNB:0,
                ether:0
            },
            totalBalance: 0,
            auctionDetails: {
                baseLinePrice: 0.01,
                todaySupply: 0,
                todayContribution: 0,
                yesterdaySupply: 0,
                yesterdayContribution: 0,
                totalContribution: 0,
                EndDate: null,
                maxContributionAllowed: 0,
                percentageProgress: 0,
                currentJNTRMarketValue: 0,
                auctionSoldOut: false,
                sinceLaunch: 100,
                remainingAvailableInvestment: 0,
            },
            userPerfomance: {
                "totalInvestMent": 0,
                "totalToken": 0,
                "stakingReturn": 0,
                "tokenValue": 0,
                "roi": 0,
                "stackToken": 0,
                "cancelledInvestMent": 0,
                "cancelledToken": 0,
                "downSideInvestment": 0,
                "lockedOn": 0,
                "lockedToken": 0
            },
        }
    }

    componentWillMount() {
        auctionStores.on("FETCH_DOWNSIDE_INFO", this.setUserPerfomance.bind(this));
        // auctionStores.on("FETCH_USER_PERFOMANCE_INFO", this.setUserPerfomance.bind(this));
        AuctionActions.fetchAuctionDetails();
        console.log("access token is:",this.props.match.params.accessToken)
        WhiteListActions.userLogin(undefined, undefined, undefined, this.props.match.params.accessToken);
        auctionStores.on("FETCH_AUCTION_DETAILS", this.fetchedAuctionDetails.bind(this));
        auctionStores.on("USER_EMAIL_LOGIN", this.updateComponent.bind(this));
        auctionStores.on("USER_WALLET_WHITELIST_UPDATE", this.updateComponent.bind(this));
        auctionStores.on("FETCH_CURRENCIES_PRICES", this.fetchedCurrenciesPrices.bind(this));
        metaMaskStore.on("META_MASK_CONNECTED", this.metaMaskConnected.bind(this))
        metaMaskStore.on("META_MASK_ADDRESS_CHANGED", this.metaAddressChange.bind(this))
        metaMaskStore.on("META_MASK_NETWORK_CHANGED", this.metaNetwrokChange.bind(this));

    }

    componentWillUnmount() {
        auctionStores.removeListener("FETCH_AUCTION_DETAILS", this.fetchedAuctionDetails.bind(this));
        auctionStores.removeListener("USER_EMAIL_LOGIN", this.updateComponent.bind(this));
        auctionStores.removeListener("USER_WALLET_WHITELIST_UPDATE", this.updateComponent.bind(this));
        auctionStores.removeListener("FETCH_CURRENCIES_PRICES", this.fetchedCurrenciesPrices.bind(this));
        metaMaskStore.removeListener("META_MASK_CONNECTED", this.metaMaskConnected.bind(this))
        metaMaskStore.removeListener("META_MASK_ADDRESS_CHANGED", this.metaAddressChange.bind(this))
        metaMaskStore.removeListener("META_MASK_NETWORK_CHANGED", this.metaNetwrokChange.bind(this));
        auctionStores.removeListener("FETCH_USER_PERFOMANCE_INFO", this.setUserPerfomance.bind(this))

    }
    setUserPerfomance() {
        let userPerfomance = auctionStores.getDownSideInfo();
        let totalInvestMent = userPerfomance.totalInvestMent - userPerfomance.cancelledInvestMent;
        let totalToken = userPerfomance.totalToken - userPerfomance.cancelledToken;
        let stakingReturn = userPerfomance.stakingReturn > 0 ? userPerfomance.stakingReturn : 0;
        let tokenValue = (Number(totalToken) + Number(stakingReturn)) * this.state.auctionDetails.currentJNTRMarketValue;
        let roi = tokenValue / totalInvestMent * 100;
        let stackToken = userPerfomance.stackToken;
        let cancelledInvestMent= userPerfomance.cancelledInvestMent;
        let cancelledToken= userPerfomance.cancelledToken;
        let downSideInvestment= userPerfomance.downSideInvestment;
        let lockedOn= userPerfomance.lockedOn;
        let lockedToken= userPerfomance.lockedToken;
        userPerfomance = { totalInvestMent: totalInvestMent, totalToken: totalToken, stakingReturn: stakingReturn, tokenValue: tokenValue, roi: roi, stackToken: stackToken ,cancelledInvestMent:cancelledInvestMent,cancelledToken:cancelledToken, downSideInvestment:downSideInvestment,lockedOn:lockedOn,lockedToken:lockedToken }
        this.setState({ userPerfomance: userPerfomance });
    }

    componentDidMount = async () => {
        metaMaskStore.checkWeb3(false);
        // this.getBalance();

        if (this.state.metamaskWallet) {
            AuctionActions.getUserDownSideInfo(this.state.metamaskWallet)
        }
    }

    metaMaskConnected() {
        this.setState({ web3Provider: metaMaskStore.getWeb3() }, () => {
            AuctionActions.fetchCurrenciesPrices();
        });
    }

    metaAddressChange() {
        this.setState({ web3Provider: metaMaskStore.getWeb3() }, () => {
            AuctionActions.fetchCurrenciesPrices();
            if (this.state.web3Provider.accounts[0]) {
                WhiteListActions.checkAddressWhiteListed(this.state.web3Provider.accounts[0]);
                 this.initInstance();
            }
        });
    }

    metaNetwrokChange() {
        this.setState({ web3Provider: metaMaskStore.getWeb3() }, () => {
            if (this.state.web3Provider.netWorkId !== CONSTANT.NETWORK_ID) {
                if (CONSTANT.NETWORK_ID === 1) {
                    notification.errorMsg("We are running on Mainnet please select Mainnet");
                } else if (CONSTANT.NETWORK_ID === 3) {
                    notification.errorMsg("We are running on Ropsten please select Ropsten");
                }
            }
        });
    }

    // get user jntr balance

 



    updateComponent = async () => {
        if (auctionStores.getLoginResponse()) {
            if (auctionStores.getLoginResponse().data.resp_code < 0) {
                notification.warningMsg("", auctionStores.getLoginResponse().data.resp_message);
                this.setState({ loading: false, redirectToLogin: true })
            } else {
                // notification.warningMsg("","Profile Page is under maintenance")
                // this.setState({
                //     loading: false,
                //     userProfile: userProfileResponse,
                    
                // })

                 var userProfileResponse = auctionStores.getLoginResponse().data.userProfile.userProfile
                if ((userProfileResponse.kycStatus === "completed" || userProfileResponse.kycStatus === "approved")  && (userProfileResponse.amlStatus === "completed" || userProfileResponse.amlStatus === "approved")) {
                    this.setState({
                        // redirectToAuction: true,
                         loading: false,
                         userProfile: userProfileResponse,
                        
                    })
                    this.initialScript();
                    this.getBalance()
                } else {
                    if (userProfileResponse.kycStatus === null) {
                        notification.warningMsg("", "KYC not completed yet!")
                    
                    setTimeout(function () {
                        this.setState({
                            userProfile: userProfileResponse,
                            loading: false,
                        }, async () => {
                            this.initialScript();
                        })
                    }.bind(this), 1000);
                }
            }
             }
        } else {
            this.setState({
                redirectToLogin: true
            })
        }
    }
    getDownSideInfo() {
        if (this.state.metamaskWallet) {
            AuctionActions.getUserDownSideInfo(this.state.metamaskWallet)
        }
    }
    initInstance() {
        const { web3Provider } = this.state;
        if (web3Provider.isLogin) {
            const whiteListInstance = new web3Provider.web3.eth.Contract(
                ContractData.WhiteListAbi, ContractData.WhiteListAddress
            );
            const downSideProtectionInstance = new web3Provider.web3.eth.Contract(
                ContractData.DownsideProtectionAbi,
                ContractData.DownsideProtectionAddress
            );
            const fundCollectorInstance = new web3Provider.web3.eth.Contract(
                ContractData.FundCollectorAbi,
                ContractData.FundCollectorAddress
            );
    
            const JNTRTokenInstance = new web3Provider.web3.eth.Contract(
                ContractData.JNTRTokenAbi,
                ContractData.JNTRTokenAddress
            )
            this.setState({
                accounts: web3Provider.accounts,
                whiteListInstance: whiteListInstance,
                downSideProtectionInstance: downSideProtectionInstance,
                fundCollectorInstance: fundCollectorInstance,
                jntrInstance:JNTRTokenInstance,
                metamaskWallet: web3Provider.accounts[0],
                ledgerWallet: web3Provider.accounts[0],
                JNTRTokenInstance :JNTRTokenInstance
            }, async () => {
                this.reconnectWebSocket();
                this.checkInvestment();
                this.getDownSideInfo();
                this.getBalance();
                AuctionActions.getUserDownSideInfo(this.state.metamaskWallet);
            })
        }



    }

    getBalance=async()=>{
        if(this.state.web3Provider.isLogin)
        {
        const { web3Provider } = this.state;
        const tokens = web3Provider.web3.utils.fromWei(await this.state.jntrInstance.methods.balanceOf(this.state.web3Provider.accounts[0]).call(), "ether");
            this.setState({jntrBalance:tokens});
        }
    }

    fetchedAuctionDetails() {
        var fetchedAuctionDetails = auctionStores.getFetchedAuctionDetails();
        const { auctionDetails } = this.state;
        auctionDetails['todaySupply'] = (fetchedAuctionDetails._todaySupply / 10 ** 18);
        auctionDetails['todayContribution'] = Number(fetchedAuctionDetails._todayContribution) / 10 ** 9;
        auctionDetails['yesterdaySupply'] = Number(fetchedAuctionDetails._yesterdaySupply) / 10 ** 18;
        auctionDetails['yesterdayContribution'] = Number(fetchedAuctionDetails._yesterdayContribution) / 10 ** 9;
        auctionDetails['maxContributionAllowed'] = (Number(fetchedAuctionDetails._maxContributionAllowed) / 10 ** 9);
        auctionDetails['totalContribution'] = (Number(fetchedAuctionDetails._totalContribution) / 10 ** 9) + (Number(fetchedAuctionDetails._todayContribution) / 10 ** 9);
        auctionDetails['remainingAvailableInvestment'] = (auctionDetails['maxContributionAllowed'] - auctionDetails['todayContribution']) < 0.00000001 ? 0 : (auctionDetails['maxContributionAllowed'] - auctionDetails['todayContribution']);
        auctionDetails['EndDate'] = fetchedAuctionDetails.EndDate;
        var percentage = ((auctionDetails['todayContribution'] / auctionDetails['maxContributionAllowed']) * 150);
        auctionDetails['percentageProgress'] = percentage;
        auctionDetails['currentJNTRMarketValue'] = fetchedAuctionDetails.currentMarketPrice;
        auctionDetails['sinceLaunch'] = auctionDetails['currentJNTRMarketValue'] / this.state.auctionDetails.baseLinePrice.toFixed(2);
        auctionDetails['auctionSoldOut'] = Number(auctionDetails['remainingAvailableInvestment']) === 0 ? true : false;
        auctionDetails["auctionDayId"] = fetchedAuctionDetails._auctionDayId;
        // auctionDetails['todaySupply'] = auctionDetails['percentageProgress'] > 100 ? auctionDetails['percentageProgress'] * auctionDetails['todaySupply'] / 100 : auctionDetails['todaySupply'];

        auctionDetails['todaySupply'] = auctionDetails['todayContribution'] > auctionDetails['yesterdayContribution'] ? ((auctionDetails['todayContribution'] / auctionDetails['yesterdayContribution']) * auctionDetails['todaySupply'] * 2) : auctionDetails['todaySupply']
        auctionDetails['individualBonus'] = fetchedAuctionDetails.individualBonus;

        this.setState({
            auctionDetails: auctionDetails
        }, () => {
            setInterval(() => {
                this.updateDateTimer();
            }, 1000)
            this.forceUpdate();
        })
    }

    updateDateTimer = async () => {
        // var input = "25 Jun 2020 00:00:00",
        //     m, 
        var endTime = moment.utc(this.state.auctionDetails.EndDate).local().format();
        endTime = Date.parse(endTime) / 1e3;
        var now = new Date(),
            timeLeft = endTime - (now = Date.parse(now) / 1e3),
            days = Math.floor(timeLeft / 86400),
            hours = Math.floor((timeLeft - 86400 * days) / 3600),
            minutes = Math.floor((timeLeft - 86400 * days - 3600 * hours) / 60),
            seconds = Math.floor(timeLeft - 86400 * days - 3600 * hours - 60 * minutes);
        if (timeLeft < 0) {
            hours = "00";
            minutes = "00";
            seconds = "00";
        }

        $(".hours1").html((hours).toString().length === 1 ? ("0" + hours) : (hours));
        $(".minutes1").html((minutes).toString().length === 1 ? ("0" + minutes) : (minutes));
        $(".seconds1").html((seconds).toString().length === 1 ? ("0" + seconds) : (seconds));

        if (hours = hours < "10" ? "<span>0</span><span>" + hours + "</span>" : "<span>" + (hours = hours.toString())[0] + "</span><span>" + hours[1] + "</span>", minutes = minutes < "10" ? "<span>0</span><span>" + minutes + "</span>" : "<span>" + (minutes = minutes.toString())[0] + "</span><span>" + minutes[1] + "</span>", seconds = seconds < "10" ? "<span>0</span><span>" + seconds + "</span>" : "<span>" + (seconds = seconds.toString())[0] + "</span><span>" + seconds[1] + "</span>", Number(days) < 0 && (days = "<span>0</span><span>0</span>", hours = "<span>0</span><span>0</span>", minutes = "<span>0</span><span>0</span>", seconds = "<span>0</span><span>0</span>"), 1 === (days = days.toString()).length) days = "<span>0</span><span>" + days + "</span>";
        else {
            let tmpDays = days;
            days = "";
            if (tmpDays > 0) {
                for (let x = 0; x < tmpDays.length; x++) days += "<span>" + tmpDays[x] + "</span>"
            } else {
                days = "<span>0</span><span>0</span>";
                hours = "<span>0</span><span>0</span>";
                minutes = "<span>0</span><span>0</span>";
                seconds = "<span>0</span><span>0</span>";
            }

        }
        $(".days").html(days); $(".hours").html(hours); $(".minutes").html(minutes); $(".seconds").html(seconds);
    }

    fetchedCurrenciesPrices() {
        this.setState({ currencyPrice: auctionStores.getFetchedCurrenciesPrice() }, () => {
            this.calculateFund();
        });
    }

    calculateFund() {
         this.initInstance()
        let { web3Provider, currencyPrice } = this.state;
        if (web3Provider.isLogin && currencyPrice != null) {
            let price = this.state.currencyPrice["0x0000000000000000000000000000000000000000"];
            // let etherPrice = web3Provider.web3.utils.fromWei(price.toString(), "mwei");
               let bnbPrice = web3Provider.web3.utils.fromWei(price.toString(), "gwei");
            web3Provider.web3.eth.getBalance(web3Provider.accounts[0], (err, accountBalance) => {
                let totalBalance = Number(web3Provider.web3.utils.fromWei(accountBalance)) * Number(bnbPrice);
                let tokenBalance={BNB:Number(web3Provider.web3.utils.fromWei(accountBalance)),ether:0}
                this.setState({
                    totalBalance: totalBalance,
                    tokenBalance:tokenBalance,
                }, () => {
                    this.forceUpdate();
                    // this.updateTokenBalance()
                });
            })
            
        }
    }

    // getting token balance from metamask
    updateTokenBalance = async () => {
        // if (this.state.web3Provider.isLogin) {
          const { JNTRTokenInstance,web3Provider } = this.state;
        // Balances
          var JNTRtokens = web3Provider.web3.utils.fromWei(await JNTRTokenInstance.methods.balanceOf(this.state.web3Provider.accounts[0]).call(), "ether");
        //   console.log("my jntr tokens",tokens)
          this.setState({JNTRToken:JNTRtokens})
    }
    // updateValue = async (e) => {
    //     try {
    //         var data = {
    //             identity: {
    //                 transaction_identity: {
    //                     first_name: $('#firstName').val(),
    //                     middle_name: $('#middleName').val(),
    //                     last_name: $('#lastName').val(),
    //                     country_code: $('#country').val(),
    //                     identity_phone_numbers: [{ phone_number: this.state.userProfile.countryCode + this.state.userProfile.phone }]
    //                 },
    //                 state: this.state.userProfile.kycStatus,
    //                 id: this.state.userProfile.kycId
    //             }
    //         }
    //         // var res = WhiteListActions.updateUser(data)
    //     }
    //     catch (err) {
    //     }
    // }

    initialScript = async () => {
        $('#main').unbind();
        // Script Start
        // var Country = [{ "name": "Israel", "dial_code": "+972", "code": "IL" }, { "name": "Afghanistan", "dial_code": "+93", "code": "AF" }, { "name": "Albania", "dial_code": "+355", "code": "AL" }, { "name": "Algeria", "dial_code": "+213", "code": "DZ" }, { "name": "AmericanSamoa", "dial_code": "+1 684", "code": "AS" }, { "name": "Andorra", "dial_code": "+376", "code": "AD" }, { "name": "Angola", "dial_code": "+244", "code": "AO" }, { "name": "Anguilla", "dial_code": "+1 264", "code": "AI" }, { "name": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG" }, { "name": "Argentina", "dial_code": "+54", "code": "AR" }, { "name": "Armenia", "dial_code": "+374", "code": "AM" }, { "name": "Aruba", "dial_code": "+297", "code": "AW" }, { "name": "Australia", "dial_code": "+61", "code": "AU" }, { "name": "Austria", "dial_code": "+43", "code": "AT" }, { "name": "Azerbaijan", "dial_code": "+994", "code": "AZ" }, { "name": "Bahamas", "dial_code": "+1 242", "code": "BS" }, { "name": "Bahrain", "dial_code": "+973", "code": "BH" }, { "name": "Bangladesh", "dial_code": "+880", "code": "BD" }, { "name": "Barbados", "dial_code": "+1 246", "code": "BB" }, { "name": "Belarus", "dial_code": "+375", "code": "BY" }, { "name": "Belgium", "dial_code": "+32", "code": "BE" }, { "name": "Belize", "dial_code": "+501", "code": "BZ" }, { "name": "Benin", "dial_code": "+229", "code": "BJ" }, { "name": "Bermuda", "dial_code": "+1 441", "code": "BM" }, { "name": "Bhutan", "dial_code": "+975", "code": "BT" }, { "name": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA" }, { "name": "Botswana", "dial_code": "+267", "code": "BW" }, { "name": "Brazil", "dial_code": "+55", "code": "BR" }, { "name": "Bulgaria", "dial_code": "+359", "code": "BG" }, { "name": "Burkina Faso", "dial_code": "+226", "code": "BF" }, { "name": "Burundi", "dial_code": "+257", "code": "BI" }, { "name": "Cambodia", "dial_code": "+855", "code": "KH" }, { "name": "Cameroon", "dial_code": "+237", "code": "CM" }, { "name": "Canada", "dial_code": "+1", "code": "CA" }, { "name": "Cape Verde", "dial_code": "+238", "code": "CV" }, { "name": "Cayman Islands", "dial_code": "+ 345", "code": "KY" }, { "name": "Central African Republic", "dial_code": "+236", "code": "CF" }, { "name": "Chad", "dial_code": "+235", "code": "TD" }, { "name": "Chile", "dial_code": "+56", "code": "CL" }, { "name": "China", "dial_code": "+86", "code": "CN" }, { "name": "Colombia", "dial_code": "+57", "code": "CO" }, { "name": "Comoros", "dial_code": "+269", "code": "KM" }, { "name": "Congo", "dial_code": "+242", "code": "CG" }, { "name": "Cook Islands", "dial_code": "+682", "code": "CK" }, { "name": "Costa Rica", "dial_code": "+506", "code": "CR" }, { "name": "Croatia", "dial_code": "+385", "code": "HR" }, { "name": "Cuba", "dial_code": "+53", "code": "CU" }, { "name": "Cyprus", "dial_code": "+537", "code": "CY" }, { "name": "Czech Republic", "dial_code": "+420", "code": "CZ" }, { "name": "Denmark", "dial_code": "+45", "code": "DK" }, { "name": "Djibouti", "dial_code": "+253", "code": "DJ" }, { "name": "Dominica", "dial_code": "+1 767", "code": "DM" }, { "name": "Dominican Republic", "dial_code": "+1 849", "code": "DO" }, { "name": "Ecuador", "dial_code": "+593", "code": "EC" }, { "name": "Egypt", "dial_code": "+20", "code": "EG" }, { "name": "El Salvador", "dial_code": "+503", "code": "SV" }, { "name": "Equatorial Guinea", "dial_code": "+240", "code": "GQ" }, { "name": "Eritrea", "dial_code": "+291", "code": "ER" }, { "name": "Estonia", "dial_code": "+372", "code": "EE" }, { "name": "Ethiopia", "dial_code": "+251", "code": "ET" }, { "name": "Faroe Islands", "dial_code": "+298", "code": "FO" }, { "name": "Fiji", "dial_code": "+679", "code": "FJ" }, { "name": "Finland", "dial_code": "+358", "code": "FI" }, { "name": "France", "dial_code": "+33", "code": "FR" }, { "name": "French Polynesia", "dial_code": "+689", "code": "PF" }, { "name": "Gabon", "dial_code": "+241", "code": "GA" }, { "name": "Gambia", "dial_code": "+220", "code": "GM" }, { "name": "Georgia", "dial_code": "+995", "code": "GE" }, { "name": "Germany", "dial_code": "+49", "code": "DE" }, { "name": "Ghana", "dial_code": "+233", "code": "GH" }, { "name": "Gibraltar", "dial_code": "+350", "code": "GI" }, { "name": "Greece", "dial_code": "+30", "code": "GR" }, { "name": "Greenland", "dial_code": "+299", "code": "GL" }, { "name": "Grenada", "dial_code": "+1 473", "code": "GD" }, { "name": "Guam", "dial_code": "+1 671", "code": "GU" }, { "name": "Guatemala", "dial_code": "+502", "code": "GT" }, { "name": "Guinea", "dial_code": "+224", "code": "GN" }, { "name": "Guinea-Bissau", "dial_code": "+245", "code": "GW" }, { "name": "Guyana", "dial_code": "+595", "code": "GY" }, { "name": "Haiti", "dial_code": "+509", "code": "HT" }, { "name": "Honduras", "dial_code": "+504", "code": "HN" }, { "name": "Hungary", "dial_code": "+36", "code": "HU" }, { "name": "Iceland", "dial_code": "+354", "code": "IS" }, { "name": "India", "dial_code": "+91", "code": "IN" }, { "name": "Indonesia", "dial_code": "+62", "code": "ID" }, { "name": "Iraq", "dial_code": "+964", "code": "IQ" }, { "name": "Ireland", "dial_code": "+353", "code": "IE" }, { "name": "Israel", "dial_code": "+972", "code": "IL" }, { "name": "Italy", "dial_code": "+39", "code": "IT" }, { "name": "Jamaica", "dial_code": "+1 876", "code": "JM" }, { "name": "Japan", "dial_code": "+81", "code": "JP" }, { "name": "Jordan", "dial_code": "+962", "code": "JO" }, { "name": "Kazakhstan", "dial_code": "+7 7", "code": "KZ" }, { "name": "Kenya", "dial_code": "+254", "code": "KE" }, { "name": "Kiribati", "dial_code": "+686", "code": "KI" }, { "name": "Kuwait", "dial_code": "+965", "code": "KW" }, { "name": "Kyrgyzstan", "dial_code": "+996", "code": "KG" }, { "name": "Latvia", "dial_code": "+371", "code": "LV" }, { "name": "Lebanon", "dial_code": "+961", "code": "LB" }, { "name": "Lesotho", "dial_code": "+266", "code": "LS" }, { "name": "Liberia", "dial_code": "+231", "code": "LR" }, { "name": "Liechtenstein", "dial_code": "+423", "code": "LI" }, { "name": "Lithuania", "dial_code": "+370", "code": "LT" }, { "name": "Luxembourg", "dial_code": "+352", "code": "LU" }, { "name": "Madagascar", "dial_code": "+261", "code": "MG" }, { "name": "Malawi", "dial_code": "+265", "code": "MW" }, { "name": "Malaysia", "dial_code": "+60", "code": "MY" }, { "name": "Maldives", "dial_code": "+960", "code": "MV" }, { "name": "Mali", "dial_code": "+223", "code": "ML" }, { "name": "Malta", "dial_code": "+356", "code": "MT" }, { "name": "Marshall Islands", "dial_code": "+692", "code": "MH" }, { "name": "Martinique", "dial_code": "+596", "code": "MQ" }, { "name": "Mauritania", "dial_code": "+222", "code": "MR" }, { "name": "Mauritius", "dial_code": "+230", "code": "MU" }, { "name": "Mayotte", "dial_code": "+262", "code": "YT" }, { "name": "Mexico", "dial_code": "+52", "code": "MX" }, { "name": "Monaco", "dial_code": "+377", "code": "MC" }, { "name": "Mongolia", "dial_code": "+976", "code": "MN" }, { "name": "Montenegro", "dial_code": "+382", "code": "ME" }, { "name": "Montserrat", "dial_code": "+1664", "code": "MS" }, { "name": "Morocco", "dial_code": "+212", "code": "MA" }, { "name": "Myanmar", "dial_code": "+95", "code": "MM" }, { "name": "Namibia", "dial_code": "+264", "code": "NA" }, { "name": "Nauru", "dial_code": "+674", "code": "NR" }, { "name": "Nepal", "dial_code": "+977", "code": "NP" }, { "name": "Netherlands", "dial_code": "+31", "code": "NL" }, { "name": "Netherlands Antilles", "dial_code": "+599", "code": "AN" }, { "name": "New Caledonia", "dial_code": "+687", "code": "NC" }, { "name": "New Zealand", "dial_code": "+64", "code": "NZ" }, { "name": "Nicaragua", "dial_code": "+505", "code": "NI" }, { "name": "Niger", "dial_code": "+227", "code": "NE" }, { "name": "Nigeria", "dial_code": "+234", "code": "NG" }, { "name": "Niue", "dial_code": "+683", "code": "NU" }, { "name": "Norfolk Island", "dial_code": "+672", "code": "NF" }, { "name": "Northern Mariana Islands", "dial_code": "+1 670", "code": "MP" }, { "name": "Norway", "dial_code": "+47", "code": "NO" }, { "name": "Oman", "dial_code": "+968", "code": "OM" }, { "name": "Pakistan", "dial_code": "+92", "code": "PK" }, { "name": "Palau", "dial_code": "+680", "code": "PW" }, { "name": "Panama", "dial_code": "+507", "code": "PA" }, { "name": "Papua New Guinea", "dial_code": "+675", "code": "PG" }, { "name": "Paraguay", "dial_code": "+595", "code": "PY" }, { "name": "Peru", "dial_code": "+51", "code": "PE" }, { "name": "Philippines", "dial_code": "+63", "code": "PH" }, { "name": "Poland", "dial_code": "+48", "code": "PL" }, { "name": "Portugal", "dial_code": "+351", "code": "PT" }, { "name": "Puerto Rico", "dial_code": "+1 939", "code": "PR" }, { "name": "Qatar", "dial_code": "+974", "code": "QA" }, { "name": "Romania", "dial_code": "+40", "code": "RO" }, { "name": "Rwanda", "dial_code": "+250", "code": "RW" }, { "name": "Samoa", "dial_code": "+685", "code": "WS" }, { "name": "San Marino", "dial_code": "+378", "code": "SM" }, { "name": "Saudi Arabia", "dial_code": "+966", "code": "SA" }, { "name": "Senegal", "dial_code": "+221", "code": "SN" }, { "name": "Serbia", "dial_code": "+381", "code": "RS" }, { "name": "Seychelles", "dial_code": "+248", "code": "SC" }, { "name": "Sierra Leone", "dial_code": "+232", "code": "SL" }, { "name": "Singapore", "dial_code": "+65", "code": "SG" }, { "name": "Slovakia", "dial_code": "+421", "code": "SK" }, { "name": "Slovenia", "dial_code": "+386", "code": "SI" }, { "name": "Solomon Islands", "dial_code": "+677", "code": "SB" }, { "name": "South Africa", "dial_code": "+27", "code": "ZA" }, { "name": "South Georgia and the South Sandwich Islands", "dial_code": "+500", "code": "GS" }, { "name": "Spain", "dial_code": "+34", "code": "ES" }, { "name": "Sri Lanka", "dial_code": "+94", "code": "LK" }, { "name": "Sudan", "dial_code": "+249", "code": "SD" }, { "name": "Suriname", "dial_code": "+597", "code": "SR" }, { "name": "Swaziland", "dial_code": "+268", "code": "SZ" }, { "name": "Sweden", "dial_code": "+46", "code": "SE" }, { "name": "Switzerland", "dial_code": "+41", "code": "CH" }, { "name": "Tajikistan", "dial_code": "+992", "code": "TJ" }, { "name": "Thailand", "dial_code": "+66", "code": "TH" }, { "name": "Togo", "dial_code": "+228", "code": "TG" }, { "name": "Tokelau", "dial_code": "+690", "code": "TK" }, { "name": "Tonga", "dial_code": "+676", "code": "TO" }, { "name": "Trinidad and Tobago", "dial_code": "+1 868", "code": "TT" }, { "name": "Tunisia", "dial_code": "+216", "code": "TN" }, { "name": "Turkey", "dial_code": "+90", "code": "TR" }, { "name": "Turkmenistan", "dial_code": "+993", "code": "TM" }, { "name": "Turks and Caicos Islands", "dial_code": "+1 649", "code": "TC" }, { "name": "Tuvalu", "dial_code": "+688", "code": "TV" }, { "name": "Uganda", "dial_code": "+256", "code": "UG" }, { "name": "Ukraine", "dial_code": "+380", "code": "UA" }, { "name": "United Arab Emirates", "dial_code": "+971", "code": "AE" }, { "name": "United Kingdom", "dial_code": "+44", "code": "GB" }, { "name": "United States", "dial_code": "+1", "code": "US" }, { "name": "Uruguay", "dial_code": "+598", "code": "UY" }, { "name": "Uzbekistan", "dial_code": "+998", "code": "UZ" }, { "name": "Vanuatu", "dial_code": "+678", "code": "VU" }, { "name": "Wallis and Futuna", "dial_code": "+681", "code": "WF" }, { "name": "Yemen", "dial_code": "+967", "code": "YE" }, { "name": "Zambia", "dial_code": "+260", "code": "ZM" },
        // { "name": "Zimbabwe", "dial_code": "+263", "code": "ZW" }, { "name": "Bolivia, Plurinational State of", "dial_code": "+591", "code": "BO" }, { "name": "Brunei Darussalam", "dial_code": "+673", "code": "BN" }, { "name": "Congo, The Democratic Republic of the", "dial_code": "+243", "code": "CD" }, { "name": "Cote d'Ivoire", "dial_code": "+225", "code": "CI" }, { "name": "Falkland Islands (Malvinas)", "dial_code": "+500", "code": "FK" }, { "name": "Guernsey", "dial_code": "+44", "code": "GG" }, { "name": "Holy See (Vatican City State)", "dial_code": "+379", "code": "VA" }, { "name": "Hong Kong", "dial_code": "+852", "code": "HK" }, { "name": "Iran, Islamic Republic of", "dial_code": "+98", "code": "IR" }, { "name": "Isle of Man", "dial_code": "+44", "code": "IM" }, { "name": "Jersey", "dial_code": "+44", "code": "JE" }, { "name": "Korea, Democratic People's Republic of", "dial_code": "+850", "code": "KP" }, { "name": "Korea, Republic of", "dial_code": "+82", "code": "KR" }, { "name": "Lao People's Democratic Republic", "dial_code": "+856", "code": "LA" }, { "name": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY" }, { "name": "Macao", "dial_code": "+853", "code": "MO" }, { "name": "Macedonia, The Former Yugoslav Republic of", "dial_code": "+389", "code": "MK" }, { "name": "Micronesia, Federated States of", "dial_code": "+691", "code": "FM" }, { "name": "Moldova, Republic of", "dial_code": "+373", "code": "MD" }, { "name": "Mozambique", "dial_code": "+258", "code": "MZ" }, { "name": "Palestinian Territory, Occupied", "dial_code": "+970", "code": "PS" }, { "name": "Pitcairn", "dial_code": "+872", "code": "PN" }, { "name": "Russia", "dial_code": "+7", "code": "RU" }, { "name": "Saint Barthélemy", "dial_code": "+590", "code": "BL" }, { "name": "Saint Helena, Ascension and Tristan Da Cunha", "dial_code": "+290", "code": "SH" }, { "name": "Saint Kitts and Nevis", "dial_code": "+1 869", "code": "KN" }, { "name": "Saint Lucia", "dial_code": "+1 758", "code": "LC" }, { "name": "Saint Martin", "dial_code": "+590", "code": "MF" }, { "name": "Saint Vincent and the Grenadines", "dial_code": "+1 784", "code": "VC" }, { "name": "Sao Tome and Principe", "dial_code": "+239", "code": "ST" }, { "name": "Somalia", "dial_code": "+252", "code": "SO" }, { "name": "Syrian Arab Republic", "dial_code": "+963", "code": "SY" }, { "name": "Taiwan, Province of China", "dial_code": "+886", "code": "TW" }, { "name": "Tanzania, United Republic of", "dial_code": "+255", "code": "TZ" }, { "name": "Timor-Leste", "dial_code": "+670", "code": "TL" }, { "name": "Venezuela, Bolivarian Republic of", "dial_code": "+58", "code": "VE" }, { "name": "Viet Nam", "dial_code": "+84", "code": "VN" }, { "name": "Virgin Islands, British", "dial_code": "+1 284", "code": "VG" }, { "name": "Virgin Islands, U.S.", "dial_code": "+1 340", "code": "VI" }]

        // function changeCountry(event) {
        //     $("#countryFlag").html('<img src="images/blank.gif" className="flag flag-' + $(event).attr("data-code") + '" alt="' + $(event).attr("data-country") + '" />');
        //     $("#countryCode").html($(event).attr("data-mobile"))
        // }
        // var html = '';
        $(".add-Credit").click(function () {
            $(".tokens-Popup02").show();
            $(".tokens-Popup05").fadeIn()
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon").click(function () {
            $(".tokens-Popup02").hide();
            $("html").removeClass("no-Scroll");
        });
        $(".dlt-confirmation").click(function () {
            $(".tokens-Popup03").show();
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon, .CancelBTN").click(function () {
            $(".tokens-Popup03").hide();
            $("html").removeClass("no-Scroll");
        });
        $(".add_WalBTN").click(function () {
            $(".tokens-Popup04").show();
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon").click(function () {
            $(".tokens-Popup04").hide();
            $("html").removeClass("no-Scroll");
        });

        $(".um-UnlockLink").click(function () {
            $(".unlock-Popup").show();
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon, .unlock-Popup .uc-btn02").click(function () {
            $(".unlock-Popup").hide();
            $("html").removeClass("no-Scroll");
        });
        // $(".metaimg-Box").click(function () {
        //     $(".wallet-Popup").show();
        //     $("html").addClass("no-Scroll");
        // });
        $(".close-Icon").click(function () {
            $(".wallet-Popup").hide();
            $("html").removeClass("no-Scroll");
        });
        $(".edit-Email").click(function () {
            $(".change-Email").show();
            $("html").addClass("no-Scroll");
        });
        $("#email").click(function () {
            $(".change-Email").show();
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon02").click(function () {
            $(".change-Email").hide();
            $("html").removeClass("no-Scroll");
        });

        $("#phoneNumber").click(function () {
            $(".change-phone").show();
            $("html").addClass("no-Scroll");
        });
        $(".edit-Phone").click(function () {
            $(".change-phone").show();
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon02").click(function () {
            $(".change-phone").hide();
            $("html").removeClass("no-Scroll");
        });

        $(".AprWalLink").click(function () {
            $(".linkNewWallet").show();
            $("html").addClass("no-Scroll");
        });
        $(".close-Icon02").click(function () {
            $(".linkNewWallet").hide();
            $("html").removeClass("no-Scroll");
        });


        // $(".change-Mailbtn").click(function () {
        //     $(".verify-Code").show();
        //     $("html").addClass("no-Scroll");
        // });
        $(".close-Icon02").click(function () {
            $(".verify-Code").hide();
            $("html").removeClass("no-Scroll");
        });
        $(".tab-Link").click(function () {
            $(".tab-Link").removeClass("active")
            $(this).addClass("active")
            $(".tab-Content").hide();
            $("#" + $(this).attr("data-id")).fadeIn("slow");
        });
        // for (let i = 0; i < Country.length; i++) {
        //     html += '<div className="joinpClist01 "><a href="# " onClick={(ev) => {ev.preventDefault();}} onClick="changeCountry(this)" data-code="' + Country[i].code.toLowerCase() + '" data-country="' + Country[i].name + '" data-mobile="' + Country[i].dial_code + '" className="clearfix"> <span><img className="flag flag-' + Country[i].code.toLowerCase() + '" alt="" /></span><span>' + Country[i].name + '</span></a></div>'
        // }
        // $("#countryCodeList").html(html)

        (function ($) {
            $(window).resize(function () {
                if ($(this).width() > 768) {
                    $(".tokens-Popup02, .joinpsCmenu02Scroller").mCustomScrollbar(); //apply scrollbar with your options 
                } else {
                    $(".tokens-Popup02").mCustomScrollbar("destroy"); //destroy scrollbar 
                }
            }).trigger("resize");
        })(jQuery);

        $(document).ready(function () {
            //  Coin Popup Script

            // izi modal script
            $("#privacy, #terms, #cockies").iziModal({
                headerColor: '#110828',
                background: '#fff',
                width: 900,
                icon: 'icon-settings_system_daydream',
                overlayClose: true,
                fullscreen: false,
                openFullscreen: false,
                borderBottom: true,
            });
            // End of izi modal script
            var wow = new wowjs.WOW({
                boxClass: 'wow', // default
                animateClass: 'animated', // default
                offset: 0, // default
                mobile: true, // default
                live: true // default      
            })
            wow.init();

            setTimeout(function () {
                new window.google.translate.TranslateElement({
                    pageLanguage: 'en'
                }, 'google_translate_element');

            }, 1000)
            // Custom Protip Function
            $(".protipNp").each(function () {
                var title = $(this).attr("data-pt-title")
                var html = "<div class='mmProtip ani-1' >" + title + " </div>"
                $(this).append(html)
            })
            $.protip();

        });
        // function openModal01() {
        //     $("#privacy").iziModal('open');
        // }
        // function openModal02() {
        //     $("#terms").iziModal('open');
        // }
        // function openModal03() {
        //     $("#cockies").iziModal('open');
        // }

        $(document).on('click', "#main", () => {
            $(".User-CoinPopup").removeClass("Open");
        })
        // Script End
    }

    whiteListAddress(key) {
        let { web3Provider, whiteListInstance } = this.state;
        if (web3Provider.isLogin) {
            const walletAddressNew = key.toLowerCase();
            if ((web3Provider.accounts[0]).toLowerCase() !== this.state.userProfile.wallets[0].toLowerCase()) {
                notification.warningMsg("", notification.Msg.WALLET_ADDRESS_WHITELISTING_FROM_INVALID_ADDRESS)
            } else {
                whiteListInstance.methods.addMoreWallets(walletAddressNew).send({ from: web3Provider.accounts[0] })
                    .on('transactionHash', (hash) => {
                        this.setState({

                        });
                    }).on('receipt', (receipt) => {
                        WhiteListActions.updateWalletList(walletAddressNew, this.props.match.params.accessToken);
                        if (receipt.status) {
                            notification.successMsg("", notification.Msg.WALLET_ADDRESS_WHITELISTED)
                        }
                    }).on("error", (error) => {
                        if (error.message.includes("User denied transaction signature")) {
                            notification.errorMsg("", notification.Msg.WALLET_ADDRESS_WHITELISTED_REJECTED)
                        }
                    })
            }
        }
    }

    reconnectWebSocket() {
        var ws = new WebSocket(WS_URL);
        this.setState({
            ws: ws
        }, () => {
            if (ws.readyState === 0 && this.state.wserr === 2) {
                var connectInterVal = setInterval(function () {
                    if (ws.readyState === 1 && this.state.wserr !== 1) {
                        notification.successMsg("Internet Connection Reestablished!");
                        clearInterval(connectInterVal);
                        AuctionActions.fetchAuctionDetails();
                        this.setState({
                            wserr: 0,
                            isNewAuctionStaring: false
                        })
                    } else if (ws.readyState === 3) {
                        clearInterval(connectInterVal);
                    }
                }.bind(this), 1000);
            }
            this.connectWebSocket();
        })
    }

    connectWebSocket = () => {
        var missed_heartbeats;
        var heartbeat_interval = null;
        var ws = this.state.ws;
        ws.onopen = () => {
            if (heartbeat_interval === null) {
                missed_heartbeats = 0;
                heartbeat_interval = setInterval(function () {
                    try {
                        missed_heartbeats++;
                        if (missed_heartbeats >= 3)
                            throw new Error("Too many missed heartbeats.");
                    } catch (e) {
                        clearInterval(heartbeat_interval);
                        heartbeat_interval = null;
                        this.setState({
                            wserr: 2
                        }, () => {
                            ws.close();
                            notification.warningMsg("", "It's seems like your internet disconnected!")
                        })
                    }
                }.bind(this), 5000);
            }
        };
        ws.onclose = () => {
            setTimeout(() => {
                this.reconnectWebSocket();
            }, 20000)
        }
        ws.onerror = err => {
            notification.warningMsg("", "Still internet connection fail!");
            this.state.ws.close();
        };

        ws.onmessage = evt => {
            let action = evt.data;
            if (action === "FUND_ADDED" || action === "AUCTION_ENDED") {
                AuctionActions.fetchAuctionDetails();
                if (action === "AUCTION_ENDED")
                    this.setState({ isNewAuctionStaring: false }, () => {
                        this.forceUpdate();
                    })

            } else if (action === "CURRENCY_UPDATE") {
                AuctionActions.fetchCurrenciesPrices();
            } else if (action === "heartbeat_msg") {
                missed_heartbeats = 0;
            }
        };
    };

    changeMetamaskAddress(address) {
        this.setState({
            metamaskWallet: address
        })
    }

    changeLedgerAddress(address) {
        // console.log("change ledger address called",address);
        this.setState({
            ledgerWallet: address
        })
    }

    jntrTokens() {
        // alert("here")

    }

    checkInvestment() {
        const { web3Provider, fundCollectorInstance } = this.state;
        fundCollectorInstance.methods.userTotalFund(web3Provider.accounts[0]).call({}, (error, userTotalFund) => {
            fundCollectorInstance.methods.userTotalReturnToken(web3Provider.accounts[0]).call({}, (error, totalGetFrom) => {
                this.setState({ JNTRvalue: totalGetFrom / 1000000000000000000, JNTRvalueUSD: totalGetFrom / 1000000000000000000 * Number(this.state.currentMarketPrice) })
            })

        })
        this.calucalteLockFund()
    }

    calucalteLockFund() {
        this.setState({ currentMarketPrice: auctionStores.getCurrentMarketValue().currentMarketPrice })
        const { web3Provider, downSideProtectionInstance } = this.state;
        if (web3Provider.isLogin && downSideProtectionInstance !== null) {
            downSideProtectionInstance.methods.lockedTokens(web3Provider.accounts[0]).call({}, (error, lockedTokens) => {
                downSideProtectionInstance.methods.unLockBlock(web3Provider.accounts[0]).call({}, (error, unLockBlock) => {
                    this.setState({
                        lockedTokens: web3Provider.web3.utils.fromWei(lockedTokens),
                        unLockBlock: unLockBlock
                    }, () => {
                        this.setState({ lockedJNTRvalueUSD: Number(this.state.lockedTokens) * this.state.currentMarketPrice })
                    })
                })
            })
        }
    }

    unlockJNTR() {
        if (!this.state.unLockBlock) {
            const { downSideProtectionInstance, lockedTokens } = this.state;
            downSideProtectionInstance.methods.unLockTokens().send({ from: this.state.accounts[0] })
                .on('transactionHash', (hash) => {
                    this.setState({
                        txHashDownSide: CONSTANT.BLOCKCHAIN_EXPLORER_LINK + "tx/" + hash,
                        tranLoader: true,
                        unlockedTokensOnSuccess: lockedTokens
                    });
                }).on('receipt', (receipt) => {
                    this.setState({ tranLoader: false, isUnlockedSuccess: receipt.status });
                    this.calucalteLockFund();
                    if (receipt.status) {
                        AuctionActions.clearUserInvestmentDownside(this.state.web3Provider.accounts[0]);
                        notification.successMsg("", notification.Msg.UNLOCK_TOKEN_SUCCESS)
                    } else {
                        notification.errorMsg("", notification.Msg.UNLOCK_TOKEN_FAILED)
                    }
                }).on("error", (error) => {
                    this.setState({ tranLoader: false });
                    if (error.message.includes("User denied transaction signature")) {
                        notification.errorMsg("", notification.Msg.TRANSACTION_REJECTED)
                    } else {
                        notification.errorMsg("Tranascation Failed")
                    }
                })
        } else {
            notification.warningMsg("", notification.Msg.UNLOCK_TOKEN_DENIED);
        }
    }

    openPopup(popup) {
        $(popup).show();
        $("html").addClass("no-Scroll");
    }

    closePopUp(popup) {
        $(popup).fadeOut();
    };

    addClass(e, eleClass, className) {
        $(eleClass).addClass(className);
        e.preventDefault();
    }

    removeClass(e, eleClass, className) {
        $(eleClass).removeClass(className);
        e.preventDefault();
    }

    copyText(refInput){
        refInput.current.select();
        document.execCommand("copy");
        notification.successMsg("copyAddress", "Address copied successfully!")
    }
    render() {
        var dummyData = [{ "Date": "Aug 15, 2019", "Transaction": "JNTR Auction Oct 3", "Sent": "10 BNB", "Received": "100000000.234242 JNTR", "ReceiptValue": "$3000", "Status": "COMPLETED" }, { "Date": "Aug 16, 2019", "Transaction": "JNTR Auction Oct 4", "Sent": "12 BNB", "Received": "9999.234242 JNTR", "ReceiptValue": "$4000", "Status": "COMPLETED" }, { "Date": "Aug 17, 2019", "Transaction": "JNTR Auction Oct 5", "Sent": "30 BNB", "Received": "786668.234242 JNTR", "ReceiptValue": "$5000", "Status": "COMPLETED" }, { "Date": "Aug 18, 2019", "Transaction": "JNTR Auction Oct 6", "Sent": "10 BNB", "Received": "9900889.234242 JNTR", "ReceiptValue": "$6000", "Status": "COMPLETED" }]
        var tableData = dummyData.map(function (obj) {
            return <tr>
                <td align="left" className="date-Txt">
                    <a href="# " onClick={(ev) => {ev.preventDefault();}}>{obj.Date}</a></td>
                <td align="center">{obj.Transaction}</td>
                <td align="center">{obj.Sent}</td>
                <td align="center">{obj.Received}</td>
                <td align="center">{obj.ReceiptValue}</td>
                <td align="center"><strong className="blue-Color">{obj.Status}</strong></td>
            </tr>
        })
        if (this.state.userProfile.wallets !== null && this.state.userProfile.wallets) {
            var metamaskAccounts = this.state.userProfile.wallets.map(function (obj) {
                return <a href="# " onClick={(ev) => {ev.preventDefault(); this.changeMetamaskAddress(obj)}}>{obj}</a>
            }.bind(this))
        }

        if (this.state.userProfile.wallets !== null && this.state.userProfile.wallets) {
            var ledgerAccounts = this.state.userProfile.wallets.map(function (obj) {
                return <a href="# " onClick={(ev) => {ev.preventDefault(); this.changeLedgerAddress(obj)}}>{obj}</a>
            }.bind(this))
        }

        if (this.state.userProfile.wallets !== null && this.state.userProfile.wallets) {
            var approvedWallets = this.state.userProfile.wallets.map(function (obj, key) {
                return <div className="AprWalBox" key={key}>
                    <span className="grey-Color">Wallet #{this.state.userProfile.wallets.indexOf(obj)}</span>
                    <span> <a href="# " onClick={(ev) => {ev.preventDefault();}} className="edit-Btn"><i className="fas fa-edit"></i></a> </span>
                    <span> <a href={CONSTANT.BLOCKCHAIN_EXPLORER_LINK + "address/" + obj} target="_blank" rel="noopener noreferrer" className="lighBlue-Color">{obj}</a></span></div>
            }.bind(this))
        }

        if (this.state.redirectToLogin)
            return (<Redirect to={`/login`} />)

        if (this.state.redirectToEmailVerification)
            return (<Redirect to="/email-verification" />)

        if (this.state.redirectToAuction)
            return (<Redirect to="/" />)

        if (this.state.loading)
            return (<Loader />)

        return (
            <main id="main" className="bodyBG01 jntr_UserMang">
                {/* <main id="main" className="bodyBG01 jntr_UserMang"> */}
                {/* <!-- <div className="dwnPro-shild npShowMD ani-1"><a href="# " onClick={(ev) => {ev.preventDefault();}} className="ani-1 faux-Link popup04"></a>
        </div>
        <div className="dwnPro-shild npShowSM ani-1"><a href="# " onClick={(ev) => {ev.preventDefault();}} className="popup04"><span>90% Downside Protection <strong>UNLOCK YOUR TOKENS</strong></span></a></div> --> */}
                {/* <div className="auc-Btnmobile showMobile">
                    <a href="# " onClick={(ev) => {ev.preventDefault();}} target="_blank">Go to the live auction</a>
                    <div id="um-timer02">
                        <div className="hours"><span>0</span><span>0</span></div>
                        <div className="minutes"><span>0</span><span>0</span></div>
                        <div className="seconds"><span>0</span><span>0</span></div>
                    </div>
                </div> */}
                {/* <!--======================= HEADER START =====================--> */}
                <Header />
                {/* <!--======================= HEADER END =====================--> */}
                <div className="main">
                    <div className="user-Bg01">
                        {/* <!--======================= USER INFO START =====================--> */}
                        <CurrentlyActiveWallet
                            approvedWallets={approvedWallets}
                            metamaskAccounts={metamaskAccounts}
                            parentState={this.state}
                            openPopup={this.openPopup}
                            jntrBalance={this.state.jntrBalance}
                            closePopUp={this.closePopUp}
                            addClass={this.addClass}
                            removeClass={this.removeClass}
                            accessToken={this.props.match.params.accessToken}
                            auctionDetails={this.state.auctionDetails}
                            userProfile = {this.state.userProfile}
                            userPerfomance = {this.state.userPerfomance}
                            JNTRToken = {this.state.JNTRToken}
                            tokenBalance = {this.state.tokenBalance}
                            totalBalance = {this.state.totalBalance}
                        ></CurrentlyActiveWallet>
                        {/* <!--======================= OTHER WALLET START =====================--> */}
                        {/* <YourOtherWallets
                            parentState={this.state}
                        ></YourOtherWallets> */}
                        {/* <!--======================= OTHER WALLET END =====================--> */}
                        {/* <!--======================= USER INFO END =====================--> */}
                        {this.state.userProfile.kycStatus !== null && this.state.userProfile.kycStatus !== "" ?
                            // <!--======================= LEDGER START =====================--> 
                            <LedgerBox
                                ledgerAccounts={ledgerAccounts}
                                tableData={tableData}
                                parentState={this.state}
                                primaryAccount = {this.state.web3Provider.accounts[0]}
                                userProfile = {this.state.userProfile}
                                ledgerWallet={this.state.ledgerWallet}
                            ></LedgerBox>
                            :
                            null
                        }
                        {this.state.userProfile.kycStatus !== null && this.state.userProfile.kycStatus !== "" ?
                            // <!--======================= LEDGER END =====================-->
                            // <!--======================= Identity Verification =====================-->
                            <IdentityVerification
                                parentState={this.state}
                            ></IdentityVerification>
                            // <!--======================= Identity Verification END =====================-->
                            :
                            null
                        }
                        {/* <!--======================= TOKEN POPUP START =====================--> */}
                        <AddFunds></AddFunds>
                        {/* <!--======================= TOKEN POPUP END =====================-->
                         <!--======================= DeleteConfirmation POPUP END =====================--> */}
                        <DeleteConfirmation></DeleteConfirmation>
                        {/* <!--======================= DeleteConfirmation POPUP END =====================-->
                <!--======================= WALLET POPUP START =====================--> */}
                        <WalletPopup></WalletPopup>
                        {/* <!--======================= WALLET POPUP END =====================-->
                <!--======================= CHANGE EMAIL POPUP START =====================--> */}
                        <ChangeEmail email={this.state.userProfile.email}></ChangeEmail>
                        {/* <!--======================= CHANGE EMAIL POPUP END =====================-->
                <!--======================= Link New Wallet POPUP START =====================--> */}
                        <LinkNewWallet
                            unapprovedWallets={this.state.userProfile.unapprovedWallets}
                            whiteListAddress={this.whiteListAddress}
                        ></LinkNewWallet>
                        {/* <!--======================= Link New Wallet POPUP END =====================-->
                <!--======================= VERIFY POPUP START =====================--> */}
                        <VerifyCode></VerifyCode>
                        {/* <!--======================= VERIFY POPUP END =====================-->
                <!--======================= CHANGE PHONE POPUP START =====================--> */}
                        <ChangePhone phone={this.state.userProfile.phone}></ChangePhone>
                        {/* <!--======================= CHANGE PHONE POPUP END =====================--> */}
                    </div>
                    {/* <!--======================= FOOTER START =====================--> */}
                    <div className="auctionMainPage">
                        <Footer
                            openPopup={this.openPopup}
                            closePopUp={this.closePopUp}
                            showSocialLinks={false}
                            web3Provider={this.state.web3Provider}
                        />
                    </div>
                    {/* <!--======================= FOOTER END =====================-->
            <!--======================= ADD WALLET POPUP =====================--> */}
                    <div className="tokens-Popup04">
                        <div className="container-Grid addfund-container">
                            <div className="addWall_msg"><i className="fas fa-check"></i> Wallet address added successfully</div>
                            <div className="Title01">Add Wallet Address Manually</div>
                            <div className="addWall_input"> <input type="text" value="Type here a wallet address" className="ani-1" />
                            </div>
                            <div className="addWall_BTN"> <a href="# " onClick={(ev) => {ev.preventDefault();}} className="btn btn-large ani-1 connected">ADD
                            NEW WALLET MANUALLY</a> </div>
                        </div>
                        <a href="# " onClick={(ev) => {ev.preventDefault();}} className="close-Icon"> </a>
                    </div>
                    {/* <!--======================= ADD WALLET POPUP END =====================-->
            <!--======================= Unlock Jointer Popup =====================--> */}
                    <div className="unlock-Popup">
                        <div className="container-Grid addfund-container">
                            <div className="Title01">Are you sure you want to unlock <span>{Number(this.state.lockedTokens).toFixed(2)}</span> JNTR?</div>
                            <div className="addWall_BTN">
                                <a href="# " onClick={(ev) => {ev.preventDefault(); this.unlockJNTR()}} className="uc-btn01">Yes</a>
                                <a href="# " onClick={(ev) => {ev.preventDefault();}} className="uc-btn02">Cancel</a>
                            </div>
                        </div>
                        <a href="# " onClick={(ev) => {ev.preventDefault();}} className="close-Icon"> </a>
                    </div>
                    {/* <!--======================= Unlock Jointer POPUP END =====================--> */}


                    {/* <!--======================= ADD ASSETS TO WALLET START =====================--> */}
                    <div className="main-Popup add-assetsPopup">
                        <div className="container-Grid">
                            <div className="Title01">Add assets to this wallet</div>
                            <div className="wallet-assetsWrap">
                                <div className="wallet-assetsBox">
                                    <div className="title-Wrap">
                                        <div className="icon-Box icon01"></div>
                                        <div className="Title02">JNTR</div>
                                    </div>
                                    <ul>
                                        <li><span className="num">1.</span> <span className="list-Text">Click to copy the smart contract address</span><div className="input-Bx" onClick={()=>this.copyText(this.copyJNTRAddressRef)} ><input type="text" id = "copyAddressProfile01" value={ContractData.JNTRTokenAddress} ref = {this.copyJNTRAddressRef}/><a href="# " onClick={(ev) => {ev.preventDefault();}}><i className="fas fa-copy"></i></a></div></li>
                                        <li><span className="num">2.</span> <span className="list-Text">Paste the address in the "Token Contract Address" field in the "Custom Token" section of your wallet</span></li>
                                        <li><span className="num">3.</span> <span className="list-Text">Click "next then "add token" to confirm</span></li>
                                    </ul>
                                </div>
                                <div className="wallet-assetsBox">
                                    <div className="title-Wrap">
                                        <div className="icon-Box icon02"></div>
                                        <div className="Title02">JNTR/ETN</div>
                                    </div>
                                    <ul>
                                        <li><span className="num">1.</span> <span className="list-Text">Click to copy the smart contract address</span><div className="input-Bx" onClick={()=>this.copyText(this.copyJNTRETNAddressRef)}><input type="text" value="0x92396FBB71d9C7F9C09Ce7843839E" ref = {this.copyJNTRETNAddressRef} /><a href="# " onClick={(ev) => {ev.preventDefault();}}><i className="fas fa-copy"></i></a></div></li>
                                        <li><span className="num">2.</span> <span className="list-Text">Paste the address in the "Token Contract Address" field in the "Custom Token" section of your wallet</span></li>
                                        <li><span className="num">3.</span> <span className="list-Text">Click "next then "add token" to confirm</span></li>
                                    </ul>
                                </div>
                                <div className="wallet-assetsBox">
                                    <div className="title-Wrap">
                                        <div className="icon-Box icon03"></div>
                                        <div className="Title02">JNTR/STOCK</div>
                                    </div>
                                    <ul>
                                        <li><span className="num">1.</span> <span className="list-Text">Click to copy the smart contract address</span><div className="input-Bx" onClick={()=>this.copyText(this.copyJNTRStockAddressRef)}><input type="text" value="0x92396FBB71d9C7F9C09Ce7843839E" ref = {this.copyJNTRStockAddressRef}/><a href="# " onClick={(ev) => {ev.preventDefault();}}><i className="fas fa-copy"></i></a></div></li>
                                        <li><span className="num">2.</span> <span className="list-Text">Paste the address in the "Token Contract Address" field in the "Custom Token" section of your wallet</span></li>
                                        <li><span className="num">3.</span> <span className="list-Text">Click "next then "add token" to confirm</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <a href="# " className="close-Icon ani-1" onClick={(ev) => {ev.preventDefault(); this.closePopUp(".add-assetsPopup") }}> </a>
                    </div>
                    {/* <!--======================= ADD ASSETS TO WALLET START =====================--> */}

                    {/* <!-- izi modal content  --> */}
                    <div id="privacy" style={{ display: "none" }} data-izimodal-title="Terms of Use">
                        <div className="privacyCotainer">
                            Coming Soon
                </div>
                    </div>
                    <div id="terms" style={{ display: "none" }} data-izimodal-title="Terms of Use">
                        <div className="privacyCotainer">
                            Coming Soon
                </div>
                    </div>
                    <div id="cockies" style={{ display: "none" }} data-izimodal-title="Terms of Use">
                        <div className="privacyCotainer">
                            <h2>EDGE196, LLC COOKIE POLICY
                        Last Updated: January 1, 2020</h2>
                            <p>This cookie policy (“Policy”) describes how EDGE196, LLC, a Delaware Limited Liability Company
                            (together with its US Fund, Cayman Fund, Master Feeder and other affiliates, (the “Company”)
                            uses technologies known as cookies, pixels, beacons, device information and local storage to
                            deliver and understand your use of Company Services, including insights into member behavior, so
                            we can improve our communications, products and services. We also use these technologies for
                            security purposes and measurement. Third parties (e.g. developers) that you interact with as you
                            use the Service may also use these technologies for a variety of purposes. We aim to be
                            transparent about how these technologies are useful to you, others and us. Because cookies are
                        used to provide you with the Service, disabling them may prevent you from using the Service.</p>
                            <p>Like most similar websites, the website located at www.edge196.com (the “Site”) uses cookies. By
                            using the Site and agreeing to this policy, you consent to our use of cookies in accordance with
                            the terms of this policy. All collection and processing of personal information is done in
                        accordance with our Privacy Policy.</p>
                            <h2>Cookies</h2>
                            <p>Cookies are small files that are placed on your browser or device by the website or app you’re
                            using. Pixel tags (also called clear GIFs, web beacons, or pixels) are small blocks of code on a
                            webpage or app that allow us to do things like read and place cookies and transmit information
                            to us or our partners. The resulting connection can include information such as a device’s IP
                            address, the time a person viewed the pixel, an identifier associated with the browser or device
                        and the type of browser being used.</p>
                            <p>Cookies may be either “persistent” cookies or “session” cookies. A persistent cookie consists of
                            a text file sent that allows a website or app to store and retrieve data on a person’s computer,
                            mobile phone or other devices. Some examples include device or HTML5 local storage and caching.
                            A session cookie, on the other hand, will expire at the end of the user session, when the web
                        browser is closed.</p>
                            <p>We may place or use these technologies when you interact with our Services, whether or not you
                            are logged in. For example, when you visit our website(s) or use our applications, we may place
                            or read cookies or receive information from your devices. We may also place cookies through a
                        pixel on a partner’s site or through developer’s applications.</p>
                            <h2>Why we use Cookies</h2>
                            <p>We use Cookies for a variety of reasons. We use them to improve our Service, to make the ads you
                            see more relevant to you, to count how many visitors we receive to a page, to help you sign up
                        for our services, to protect your data, or to remember your advertising settings.</p>
                            <p>While specific names of the cookies and similar technologies that we use may change from time to
                        time as we improve and update our Service, they fall into the below categories of use:</p>
                            <h2>Authentication</h2>
                            <p>These technologies tell us when you are logged in so we can show you your dashboard, cards,
                            transactions and other information about your account. They also give us information about your
                            use of the Service that we use for a variety of reasons, including making your member experience
                        better.</p>
                            <h2>Security</h2>
                            <p>These technologies help us detect potential or real abuse, Account compromises, multiple logins,
                            and other activity. They help us determine if the browser you’re using is new and give us
                            information about active sessions related to your account. These technologies can also help us
                            detect abuse and violations of terms and policies that are in place to protect us and our
                            members, for example, attempting to determine activity is automated or human - initiated.
                    </p>
                            <h2>Features</h2>
                            <p>These technologies can help make your use of the Service smoother and easier by remembering the
                            information you provided and allowing us to tailor your experience. For example, we may be able
                            to store certain preferences or show you relevant information about your value exchanges or
                            otherwise learn when you have interacted with something on the Service.
                        Advertising</p>
                            <p>These technologies are used to help us display advertisements on other platforms or on our own
                        that may be relevant to you.</p>
                            <h2>Analytics</h2>
                            <p>We may also use the technologies for general research and to understand how members are using the
                            Service and / or third - party applications.
                    </p>
                            <h2>Cookie Consent</h2>
                            <p>We use cookies to store your preferences in relation to the use of cookies more generally. If you
                        delete this cookie, your preferences will not be remembered by the site.</p>
                            <h2>Use of Cookies on Mobile Devices</h2>
                            <p>Many mobile devices contain browsers, not unlike browsers for computers. When applicable, we will
                            use cookies in the same way we do if you are using the Service via your computer. If you consume
                            the Service on devices that use local storage, Software Development Kits (SDKs) or Advanced
                            Programming Interfaces (APIs), we will use these technologies to accomplish the same purposes.
                    </p>
                            <p>We will use information about your device in ways consistent with the above and to improve the
                            Service. We will collect and use the information on transactions including payment information
                            any applicable account, credit or debit card number and other card information, and other
                        account and authentication information relating to any transactions.</p>
                            <p>As on the web, we also may use these technologies to store an identifier or other information on
                            your device. We describe how we use these technologies and the information we received through
                        their use above.</p>
                            <h2>Reading Cookies</h2>
                            <p>Web browsers send any cookies for a particular web domain to the website each time a device with
                            those cookies accesses content served from that domain. This means that any EDGE196.com cookie
                            will be sent to us when any page is accessed at EDGE196.com by that device. It also means that
                            these cookies are sent to us when someone accesses a third-party website or application that
                        integrates or uses our Service.</p>
                            <p>We may work with partners so that we can place or read cookies on your browsers or devices when
                            you visit third-party services. This allows us to do things like read and reference cookies from
                            more than one device or browser that you use, on and off of our Service, so we can provide you
                            with consistent service across all of your devices and improve and understand your experience.
                    </p>
                            <h2>Third Party Cookies</h2>
                            <p>We sometimes use third parties in connection with the Service, including analytics providers,
                            advertising networks, and developers of applications that you can access through our platform.
                            They may use a pixel to collect information about your device so that they or we can identify
                            you. If you authorize an application on our platform, their developers may also use cookies,
                            pixels or similar technologies (like local storage or information from your device), to help
                            provide you with relevant services. For example, a developer or platform partner may use
                            cookies, software developer kits (SDKs) or similar technologies to customize your experience
                            while you’re using their app. Developers or our partners also may use these technologies to help
                        share information with us, like how you use their website or application.</p>
                            <p>Those developing on our Platform may collect information when you view or use them, including
                            information about you and your device or browser. They may do this using cookies or similar
                            technologies. We require developers to be transparent about what they collect and how they use
                            the information. To learn more about the information they collect or receive, please review
                        their privacy policies.</p>
                            <h2>Control of Cookie Settings</h2>
                            <p>Your browser or device may offer settings related to these technologies, including how to delete
                            or block them. For more information about whether these settings are available, what they do,
                            and how they work, visit your browser or device's help material. If you disable certain
                            settings, we may not be able to recognize or respond to browser or device information, and that
                        may interfere with your use of the Service or certain features of the Service. </p>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

export default Profile;